import { apiClient } from './apiService';
import { REPORTS_SALES_SUMMARY } from './endpoints';
import {
  SalesSummary,
  SalesSummaryQuery
} from '@/types/SalesSummary.interface';
import { salesSummaryParams, toQueryString } from '@/utils/salesReport';

export const reportService = {
  /** Web POS "Raporlar" ile birebir aynı istek (bkz. utils/salesReport.ts). */
  async getSalesSummary(query: SalesSummaryQuery): Promise<SalesSummary> {
    const qs = toQueryString(salesSummaryParams(query));
    const response = await apiClient.get<SalesSummary>(
      `${REPORTS_SALES_SUMMARY}?${qs}`
    );
    return response.data;
  }
};
